import Box from '@mui/material/Box';
import type { Theme } from '@mui/material/styles';
import { getOpenXAgentGradient } from '../colors';
import { OpenXAgentIcon } from './OpenXAgentIcon';

const getButtonStyles = (theme: Theme) => ({
  background: getOpenXAgentGradient(theme),
  width: 24,
  height: 24,
  borderRadius: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  p: 0.6,
  paddingBottom: 0.75,
  cursor: 'pointer',
});

export const MenuItemIcon = () => {
  return (
    <Box sx={getButtonStyles}>
      <OpenXAgentIcon />
    </Box>
  );
};
